module.exports = __webpack_public_path__ + "img/business.c25ee55c.svg";